import React from 'react';
import { navigateTo } from '@/shared/utils/navigation';
import './NavbarBrand.css';

export function NavbarBrand() {
  const handleClick = (e) => {
    e.preventDefault();
    navigateTo('/');
  };

  return (
    <a href="/" className="navbar-brand" onClick={handleClick}>
      <span className="navbar-brand__logo-text">
        AIMERS<span className="navbar-brand__logo-dot">.</span>
      </span>
    </a>
  );
}
